import { Factory, trait } from 'miragejs';
import { faker } from '@faker-js/faker';
import { CTA_TYPE } from '@modules/service/constants';

faker.seed(1);

const types = [
	{ id: 1, name: 'Regulatorias', priority: 1 },
	{ id: 2, name: 'Comerciales', priority: 2 },
	{ id: 3, name: 'Operativas', priority: 3 },
];

const spaces = [
	{ id: '1', name: 'prelogin' },
	{ id: '2', name: 'Post login' },
	{ id: '3', name: 'Posición global (banner)' },
	{ id: '4', name: 'Marketing' },
	{ id: '5', name: 'Post operative' },
];

const images = [
	'/public/news/w1cut.jpg',
	'/public/news/m1cut.jpg',
	'/public/news/w2cut.jpg',
	'/public/news/m2cut.jpg',
	'/public/news/w3cut.jpg',
	'/public/news/m3cut.jpg',
	'/public/news/m4cut.jpg',
];

export default Factory.extend({
	type: () => faker.helpers.arrayElement(types),
	space: () => faker.helpers.arrayElement(spaces),
	creationDate: () => faker.date.past().toISOString(),
	title: () => faker.lorem.sentence(),
	body: () => faker.lorem.sentences(10),
	imageURL: () => faker.helpers.arrayElement(images),
	feedback: () => faker.helpers.arrayElement([-1, 0, 1]),
	impressions: 0,
	ctaText: 'Pulse aquí',
	ctaAction: CTA_TYPE.OPEN_INTERNAL,
	ctaRedirect: '/main/personal-area',
	deeplinks: { webLink: '/main/personal-area/gdpr' },
	blocking: false,

	// ── Space traits ──

	prelogin: trait({
		space: spaces[0],
		body() {
			return `(Prelogin) ${faker.lorem.sentences(10)}`;
		},
	}),

	postlogin: trait({
		space: spaces[1],
		body() {
			return `(Post login) ${faker.lorem.sentences(10)}`;
		},
	}),

	banner: trait({
		space: spaces[2],
		body() {
			return `(Banner) ${faker.lorem.sentences(10)}`;
		},
	}),

	marketing: trait({
		space: spaces[3],
		body() {
			return `(Marketing) ${faker.lorem.sentences(10)}`;
		},
	}),

	postOperative: trait({
		space: spaces[4],
		surveyOperationType: { name: 'globalPosition' },
		body() {
			return `(Post operative) ${faker.lorem.sentences(10)}`;
		},
	}),

	// ── CTA type traits ──

	openInternal: trait({
		ctaAction: CTA_TYPE.OPEN_INTERNAL,
		ctaRedirect: '/main/personal-area',
		afterCreate(c) {
			c.update({
				body: `[OPEN_INTERNAL] ${c.body}`,
			});
		},
	}),

	openExternal: trait({
		ctaAction: CTA_TYPE.OPEN_EXTERNAL,
		ctaRedirect: 'https://pensiones.cbnk.es/personas',
		afterCreate(c) {
			c.update({
				body: `[OPEN_EXTERNAL] ${c.body}`,
			});
		},
	}),

	openFile: trait({
		ctaAction: CTA_TYPE.OPEN_FILE,
		ctaRedirect: '',
		afterCreate(c) {
			c.update({
				body: `[OPEN_FILE] ${c.body}`,
			});
		},
	}),

	acceptance: trait({
		ctaAction: CTA_TYPE.ACCEPTANCE,
		ctaRedirect: 'http://www.ejemplo.html?service=gdpr',
		afterCreate(c) {
			c.update({
				body: `[ACCEPTANCE] ${c.body}`,
			});
		},
	}),

	openFunctionality: trait({
		ctaAction: CTA_TYPE.OPEN_FUNCTIONALITY,
		ctaRedirect: '',
		afterCreate(c) {
			c.update({
				body: `[OPEN_FUNCTIONALITY] ${c.body}`,
			});
		},
	}),

	openIframe: trait({
		ctaAction: CTA_TYPE.OPEN_IFRAME,
		ctaRedirect: 'https://pensiones.cbnk.es/personas',
		link: 'https://pensiones.cbnk.es/personas',
		afterCreate(c) {
			c.update({
				body: `[OPEN_IFRAME] ${c.body}`,
			});
		},
	}),
});
